import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink, Calendar, User } from 'lucide-react';

const ArticleCard = ({ article, featured = false }) => {
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric' 
    });
  };

  // Check if this is a positive community story
  const isPositiveStory = ['youth-sports', 'local-heroes', 'community-events', 'good-deeds'].includes(article.category);
  
  return (
    <article className={`group ${
      featured ? 'border-b pb-8' : ''
    }`}>
      <Link to={`/article/${article.slug}`} className="block">
        {/* Image */}
        <div className="relative overflow-hidden bg-gray-200 mb-4 rounded-sm">
          <img
            src={article.image}
            alt={article.title}
            className={`w-full object-cover group-hover:scale-105 transition-transform duration-300 ${
              featured ? 'h-96' : 'h-64'
            }`}
          />
        </div>

        {/* Category */}
        <div className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-2">
          {article.category.replace('-', ' ')}
        </div>

        {/* Title */}
        <h2 className={`font-serif font-bold leading-tight mb-2 group-hover:text-gray-600 transition-colors ${
          featured ? 'text-3xl lg:text-4xl' : 'text-xl lg:text-2xl'
        }`}>
          {article.title}
        </h2>

        {/* Excerpt */}
        <p className={`text-gray-700 leading-relaxed mb-3 ${
          featured ? 'text-base lg:text-lg' : 'text-sm lg:text-base'
        }`}>
          {article.excerpt}
        </p>
      </Link>

      {/* Meta Info */}
      <div className="flex flex-wrap items-center gap-4 text-sm text-gray-600 mb-3">
        <div className="flex items-center gap-1">
          <User size={14} />
          <span>{article.author}</span>
        </div>
        <div className="flex items-center gap-1">
          <Calendar size={14} />
          <span>{formatDate(article.published_date)}</span>
        </div>
      </div>

    </article>
  );
};

export default ArticleCard;